import React, { useContext } from 'react';
import { DraggableItemData } from '../../../../Common/DraggableItem';
import NotFound from '../../../../../components/NotFound/NotFound';
import { CustomFieldContext } from '../../../../../../context/CustomFieldContext';
import { CustomFieldEntityType } from '../../../../../../types/custom_field';
import {
  AssetExportConfiguration,
  AssetExportConfigurationField,
  AssetExportConfigurationInput,
} from '../../../../../../types/asset_export_configuration';
import ExportConfigurationForm, {
  DraggableExportFieldIdentifier,
} from '../../../../../components/Export/ExportConfigurationForm';
import { translate } from '../../../../../../types/translation/Translator';

interface AssetExportConfigurationMapping {
  value: string;
  index: number;
  field: AssetExportConfigurationField;
}

export interface DraggableAssetExportFieldIdentifier
  extends DraggableExportFieldIdentifier<AssetExportConfigurationField>,
    AssetExportConfigurationMapping {}

interface AssetExportConfigurationFormProps {
  input?: AssetExportConfigurationInput;
  setInput: React.Dispatch<React.SetStateAction<AssetExportConfigurationInput>>;
  footer: (configuration: AssetExportConfigurationInput, items: DraggableAssetExportFieldIdentifier[]) => JSX.Element;
  loading?: boolean;
}

export default function AssetExportConfigurationForm({
  input,
  setInput,
  footer,
  loading = false,
}: AssetExportConfigurationFormProps) {
  if (!input) return <NotFound />;

  const { customFields } = useContext(CustomFieldContext);

  const draggableItems: DraggableAssetExportFieldIdentifier[] =
    DraggableItemData.forExportConfiguration<AssetExportConfigurationField>([
      ...Object.values(AssetExportConfigurationField).map(field => ({ field, label: translate({ key: field }) })),
      ...[...customFields.values()]
        .filter(
          item =>
            item.entityType === CustomFieldEntityType.productMasterData ||
            item.entityType === CustomFieldEntityType.asset,
        )
        .map(item => ({ field: item.id, label: item.name })),
    ]);

  return (
    <ExportConfigurationForm
      placeholder={'Add asset export field'}
      loading={loading}
      input={input}
      setInput={setInput}
      footer={footer}
      draggableItems={draggableItems}
      toDraggableItems={AssetExportConfiguration.toDraggableItems}
    />
  );
}
